import { ChangeDetectorRef, Component, EventEmitter, Inject, Injector, Input, LOCALE_ID, OnInit, Optional, Output, TemplateRef, ViewChild } from '@angular/core';
import { HttpService } from '@ecp-caf/caf-common';
import { MessagerService } from '@farris/ui-messager';
import { TypeConverter } from '@farris/ide-property-panel';
import { ExprEditMode, ExpressionService, InjectedType, VarEntity } from '@gsp-svc/expression';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { CheckCondition } from './check-condition';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'lib-check-condition',
  templateUrl: './check-condition.component.html',
  styleUrls: ['./check-condition.component.css'],
  providers: [
     WfLocalePipe,
  ]
})
export class CheckConditionComponent implements OnInit {

  readonly groupIcon = '<i class="f-icon f-icon-lookup"></i>';

  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @Input()
  set value(data: CheckCondition[]) {
    if (data && data.length > 0) {
      console.log(data);
      this.activityBeforeStarted = data.find(d => d.checkTime === 'ACTIVITY_BEFORE_STARTED') || new CheckCondition('ACTIVITY_BEFORE_STARTED');
      this.activityBeforeCompleted = data.find(d => d.checkTime === 'ACTIVITY_BEFORE_COMPLETED') || new CheckCondition('ACTIVITY_BEFORE_COMPLETED');
    }
  }

  languages = [
    { code: 'zh-CHS', name: this.localePipe.transform('component.checkCondition.zhChs') },
    { code: 'zh-CHT', name: this.localePipe.transform('component.checkCondition.zhCht') },
    { code: 'en', name: this.localePipe.transform('component.checkCondition.en') }
  ];

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;

  activityBeforeStarted: CheckCondition = new CheckCondition('ACTIVITY_BEFORE_STARTED');
  activityBeforeCompleted: CheckCondition = new CheckCondition('ACTIVITY_BEFORE_COMPLETED');

  modalConfig = {
    title: this.localePipe.transform('component.checkCondition.checkCondition'),
    width: 440,
    height: 460,
    showButtons: true
  };

  constructor(
    private injector: Injector,
    private message: MessagerService,
    private designerUIState: ProcessDesignerUIState,
    private expr: ExpressionService,
    private http: HttpService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
  }

  editCondition(checkTime: string) {
    let context = new Array<VarEntity>();
    // if(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage')) {
    //   context.push(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage'));
    // }
    // this.expr.clearContext();
    if (this.designerUIState.schemas.length > 0) {
      for (const schema of this.designerUIState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerUIState.schemas[0].entityTypes && this.designerUIState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerUIState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    context = this.designerUIState.addContext(context);
    if (this.designerUIState.subActivityContext.length > 0) {
      for (const variable of this.designerUIState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.designerUIState.activityComponentContext.length > 0) {
      for (const variable of this.designerUIState.activityComponentContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    const text = checkTime === 'ACTIVITY_BEFORE_STARTED' ? this.activityBeforeStarted.value : this.activityBeforeCompleted.value;
    this.expr.addExpressionText(text);
    this.expr.setEditPattern(ExprEditMode.Conditional); // 默认打开简易表达式编辑器
    this.expr.buildExpression().then((cond: string) => {
      if (checkTime === 'ACTIVITY_BEFORE_STARTED') {
        this.activityBeforeStarted.value = cond;
      } else {
        this.activityBeforeCompleted.value = cond;
      }
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }

  clearCondition(checkTime: string) {
    if (checkTime === 'ACTIVITY_BEFORE_STARTED') {
      this.activityBeforeStarted.value = null;
    } else {
      this.activityBeforeCompleted.value = null;
    }
  }

  clickOK() {
    const checkConditions = new Array();
    if (this.activityBeforeStarted.value || this.activityBeforeStarted.errorTips) {
      checkConditions.push(this.activityBeforeStarted);
    }
    if (this.activityBeforeCompleted.value || this.activityBeforeCompleted.errorTips) {
      checkConditions.push(this.activityBeforeCompleted);
    }
    const object = { value: checkConditions, parameters: null };
    this.submitModal.emit(object);
  }

  clickCancel() {
    this.closeModal.emit();
  }

  validator() {

  }
}
export class CheckConditionConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: any): string {
    if (data && data.length > 0) {
      return this.localePipe.transform("component.checkCondition.set");
    }
    return this.localePipe.transform("component.checkCondition.notSet");
  }
}

